import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModelWithUser } from './base';
import { ELargeLanguageModelRequestAction } from './large-language-model-request';

/**
 * Represents the properties of a parameter for the large language model prompt.
 */

/**
 * Represents a parameter for the large language model prompt.
 */

/**
 * Enum representing function names used in the tool definition.
 */
export let ELargeLanguageModelPromptToolDefinitionFunctionDefinitionName;

/**
 * Represents the mapping between origin path and result path for a function's return value.
 */
(function (ELargeLanguageModelPromptToolDefinitionFunctionDefinitionName) {
  ELargeLanguageModelPromptToolDefinitionFunctionDefinitionName["GetAppointments"] = "GetAppointments";
})(ELargeLanguageModelPromptToolDefinitionFunctionDefinitionName || (ELargeLanguageModelPromptToolDefinitionFunctionDefinitionName = {}));
/**
 * Represents a function definition in the tool definition for large language model prompts.
 */
/**
 * Represents the tool definition for the large language model prompt.
 */
/**
 * Enum representing the role of the prompt in a conversation.
 */
export let ELargeLanguageModelPromptDefinitionRole;

/**
 * Represents a single prompt definition for large language models.
 */
(function (ELargeLanguageModelPromptDefinitionRole) {
  ELargeLanguageModelPromptDefinitionRole["System"] = "system";
  ELargeLanguageModelPromptDefinitionRole["User"] = "user";
  ELargeLanguageModelPromptDefinitionRole["Assistant"] = "assistant";
})(ELargeLanguageModelPromptDefinitionRole || (ELargeLanguageModelPromptDefinitionRole = {}));
/**
 * Interface representing a large language model prompt.
 */
export const fieldsLargeLanguageModelPrompt = _extends({}, fieldsIBaseModelWithUser, {
  action: {
    type: 'Option',
    values: ELargeLanguageModelRequestAction
  },
  definition: {
    type: 'Object',
    array: true
  },
  description: {
    type: 'Text'
  },
  name: {
    type: 'Text'
  },
  toolDefinition: {
    type: 'Object'
  }
});